<template>
  <div id="app">
    <router-view />
    
  </div>
</template>
<script>
import home from "./components/home.vue";
export default {
  components: {
    home,
  },
  data() {
    return {};
  },
  computed: {
    arr() {
      const res = [];
      for (let index = 0; index < 1000; index++) {
        res.push({ name: index });
      }
      return res;
    },
  },
};
</script>
<style>
#app {
  /* height: 100vh; */
}

p {
  margin: 0;
}


</style>
